import { render } from "./EditEducation.vue?vue&type=template&id=72e61908"
import script from "./EditEducation.vue?vue&type=script&lang=js"
export * from "./EditEducation.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__